"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
var Messages;
(function (Messages) {
    Messages["UPDATE_SETTINGS"] = "UPDATE_SETTINGS";
})(Messages || (Messages = {}));
exports.Messages = Messages;
//# sourceMappingURL=constants.js.map